import { InspectionPOItem } from 'app/modules/inspection/types';
import { Defects } from './Defects';
import { calculateDefects } from './helper';
import { Col, Row } from 'antd';
import { QMASLazyDocument, Status } from 'app/modules/ui';
import classes from './Workmanship.module.scss';

export const DESCRIPTION_DEFECT = [
  {
    label: 'Defect',
    dataIndex: 'defectName',
    span: 3,
    render: (value, record) => {
      const defectName = [];
      if (record.defectGroup) {
        defectName.push(record.defectGroup);
      }
      if (value) {
        if (record.defectClassification) {
          defectName.push(
            `${record.defectName} (${record.defectClassification})`
          );
        } else {
          defectName.push(record.defectName);
        }
      }
      return defectName.length ? defectName.join(' - ') : 'N/A';
    }
  },
  {
    label: 'Quantity',
    dataIndex: 'quantity',
    span: 3,
    render: (value) => {
      return ['null', 'undefined'].includes(typeof value) ? 'N/A' : value;
    }
  },
  {
    label: 'Description',
    dataIndex: 'description',
    span: 3,
    render: (value) => value || 'N/A'
  },
  {
    label: 'Reference Media',
    dataIndex: 'referenceMedia',
    className: 'reference-media',
    span: 3,
    render: (value: string) => {
      if (Array.isArray(value)) {
        return (
          <div style={{ display: 'flex', gap: '10px' }}>
            {value.map((item) => {
              return (
                <QMASLazyDocument
                  key={item}
                  alt="attachments"
                  documentId={item}
                />
              );
            })}
          </div>
        );
      }
      return null;
    }
  }
];

export const DESCRIPTION_DEF = [
  {
    label: 'Workmanship Progress',
    dataIndex: 'progress',
    span: 3,
    render: (value: string) => {
      return value || 'N/A';
    }
  },
  {
    label: null,
    dataIndex: 'defects',
    span: 3,
    render: (_, __, meta) => {
      const { defects } = meta;

      if (!defects) {
        return null;
      }
      return <Defects config={DESCRIPTION_DEFECT} value={defects} />;
    }
  }
];

export const DESCRIPTION_RESULT = [
  {
    label: 'Total defect found',
    dataIndex: 'defects',
    span: 3,
    className: 'aql',
    render: (
      _,
      __,
      meta: {
        poItem: InspectionPOItem;
        defects?: Array<{
          defectClassification: 'minor' | 'major' | 'critical';
          defectGroup: string;
          defectName: string;
          description: string;
          quantity: string | number;
          referenceMedia: number[];
        }>;
      }
    ) => {
      const { defects = [] } = meta;
      const { critical, major, minor } = calculateDefects(defects);

      return (
        <Row className={classes.aqlItem} style={{ width: '100%' }}>
          <Col span={6} className={classes['aqlItem__title']}>
            Total defect found
          </Col>
          <Col span={6}>
            <div className={classes['aqlItem__content']}>
              <span>Critical</span>
              <span className={classes['aqlItem__content__value']}>
                {critical}
              </span>
            </div>
          </Col>
          <Col span={6}>
            <div className={classes['aqlItem__content']}>
              <span>Major</span>
              <span className={classes['aqlItem__content__value']}>
                {major}
              </span>
            </div>
          </Col>
          <Col span={6}>
            <div className={classes['aqlItem__content']}>
              <span>Minor</span>
              <span className={classes['aqlItem__content__value']}>
                {minor}
              </span>
            </div>
          </Col>
        </Row>
      );
    }
  },
  {
    label: 'Request by AQL',
    dataIndex: 'defects',
    span: 3,
    className: 'aql',
    render: (
      _,
      __,
      meta: {
        poItem: InspectionPOItem;
      }
    ) => {
      const { poItem } = meta;
      const { aql } = poItem;

      return (
        <Row className={classes.aqlItem} style={{ width: '100%' }}>
          <Col span={6} className={classes['aqlItem__title']}>
            Request by AQL
          </Col>
          <Col span={6}>
            <div className={classes['aqlItem__content']}>
              <span>Critical</span>
              <span className={classes['aqlItem__content__value']}>
                {aql?.critical?.acceptanceLevel}
              </span>
            </div>
          </Col>
          <Col span={6}>
            <div className={classes['aqlItem__content']}>
              <span>Major</span>
              <span className={classes['aqlItem__content__value']}>
                {aql?.major?.acceptanceLevel}
              </span>
            </div>
          </Col>
          <Col span={6}>
            <div className={classes['aqlItem__content']}>
              <span>Minor</span>
              <span className={classes['aqlItem__content__value']}>
                {aql?.minor?.acceptanceLevel}
              </span>
            </div>
          </Col>
        </Row>
      );
    }
  },
  {
    label: '',
    dataIndex: 'producedQuantity',
    render: (
      _,
      __,
      meta: {
        poItem: InspectionPOItem;
        defects?: Array<{
          defectClassification: 'minor' | 'major' | 'critical';
          defectGroup: string;
          defectName: string;
          description: string;
          quantity: string | number;
          referenceMedia: number[];
        }>;
      }
    ) => {
      const { poItem, defects } = meta;
      const { aql } = poItem;

      const total = calculateDefects(defects);
      const { critical, major, minor } = total;

      const getStatusByCount = (value: number, acceptanceLevel: number) => {
        if (value > acceptanceLevel) return { value: 'Failed', color: 'error' };
        return { value: 'Passed', color: 'success' };
      };

      return (
        <Row className={classes.result} style={{ width: '100%' }}>
          <Col span={6} className={classes['result__title']}>
            Result
          </Col>
          <Col span={6} className={classes['result__content']}>
            <Status
              type="text"
              {...getStatusByCount(critical, aql?.critical?.acceptanceLevel)}
            />
          </Col>
          <Col span={6} className={classes['result__content']}>
            <Status
              type="text"
              {...getStatusByCount(major, aql?.major?.acceptanceLevel)}
            />
          </Col>
          <Col span={6} className={classes['result__content']}>
            <Status
              type="text"
              {...getStatusByCount(minor, aql?.major?.acceptanceLevel)}
            />
          </Col>
        </Row>
      );
    }
  }
];
